// Hosted API. Override with VITE_API_BASE_URL (Vercel / .env.local).
export const DEFAULT_API_BASE_URL = 'https://cosmic-learning-api.fly.dev'

export function normalizeApiBaseUrl(url) {
  return String(url || '').trim().replace(/\/+$/, '')
}
